// extracted by mini-css-extract-plugin
export default {"Portfolio":"Portfolio_Portfolio__WGOez"};